import {
  Button,
  Container,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';

import { Title } from '../../enum/title.enum';
import { useTypedDispatch, useTypedSelector } from '../../store/store';
import { signInThunk } from '../../store/thunks/user';
import { SignIn as DataInterface } from '../../types/signin.interface';
import { EmailHelper } from './enum/email-helper.enum';
import { Label } from './enum/label.enum';
import { PasswordHelper } from './enum/password-helper.enum';
import styles from './Login.module.scss';
import { emailRegex } from './regexp';

const SignIn: React.FC = () => {
  const dispatch = useTypedDispatch();
  const { loadingCounter } = useTypedSelector(state => state.toasts);
  const { register, handleSubmit, errors } = useForm();

  const onSubmit = (data: DataInterface) => {
    dispatch(signInThunk(data));
  };

  let emailHelper: string;

  switch (errors.email?.type) {
    case 'required':
      emailHelper = EmailHelper.required;
      break;
    case 'pattern':
      emailHelper = EmailHelper.error;
      break;

    default:
      emailHelper = EmailHelper.ok;
      break;
  }

  return (
    <Container component={Paper} maxWidth="xs" className={styles.container}>
      <Helmet title={Title.Login} />
      <div className={styles.formWrapper}>
        <Typography variant="h6" className={styles.enter} color="primary">
          Вход
        </Typography>
        <form className={styles.form} onSubmit={handleSubmit(onSubmit)}>
          <TextField
            className={styles.field}
            variant="outlined"
            margin="normal"
            fullWidth
            name="email"
            label={Label.email}
            inputRef={register({ required: true, pattern: emailRegex })}
            autoFocus
            error={errors.email}
            helperText={emailHelper}
          />
          <TextField
            className={styles.field}
            variant="outlined"
            margin="normal"
            fullWidth
            name="password"
            type="password"
            inputRef={register({ required: true })}
            label={Label.password}
            error={errors.password}
            helperText={errors.password && PasswordHelper.error}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={styles.submit}
            disabled={!!loadingCounter}
          >
            Войти
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default SignIn;
